export const enum ReportGenerationStatus {
    generationStarted = 0,
    dumpPatchCreated = 1,
    tempAttachmentsCopied = 2,
    attachmentsManifestUploaded = 3,
    dumpPatchUploaded = 4,
    reportConfigUploaded = 5,
    appConfigUploaded = 6,
    generationConfigUploaded = 7,
    generationPending = 8,
    generationProcessing = 9,
    // = 30%

    generationProcessed = 10,
    // = 60%

    adoptionStarted = 11,
    outputAttachmentsManifestDownloaded = 12,
    outputAttachmentDownloaded = 13,
    // = 90%

    generationDone = 14,
    // = 100%

    adoptingDone = 15,
}
